// Skill.jsx
import React, { useState, useEffect } from 'react';
import './Skill.css';

const Skill = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [animatedSkills, setAnimatedSkills] = useState([]);

  const skillCategories = {
    languages: {
      title: 'Coding Languages',
      color: '#2E7D32',
      skills: ['C', 'C++', 'Dart', 'Python', 'Java', 'JavaScript']
    },
    development: {
      title: 'Web & Mobile Development',
      color: '#1565C0',
      skills: ['Flutter', 'React JS', 'HTML5', 'CSS', 'Material-UI', 'WordPress']
    },
    data: {
      title: 'Database Management',
      color: '#EF6C00',
      skills: ['MySQL', 'MongoDB']
    },
    techstack: {
      title: 'Frameworks & Tools',
      color: '#6A1B9A',
      skills: ['TensorFlow', 'Git', 'GitHub', 'Kali Linux Tools & Commands']
    },
    concepts: {
      title: 'Core Competencies',
      color: '#C62828',
      skills: ['Data Structures & Algorithms', 'Machine Learning', 'Prompt Engineering']
    }
  };
  

  useEffect(() => {
    // Animate skills one by one
    const timer = setTimeout(() => {
      const allSkills = Object.values(skillCategories).flatMap(category => 
        category.skills.map(skill => skill)
      );
      
      const animateSequence = [];
      for (let i = 0; i < allSkills.length; i++) {
        setTimeout(() => {
          setAnimatedSkills(prev => [...prev, allSkills[i]]);
        }, i * 100);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const filteredSkills = activeCategory === 'all' 
    ? Object.values(skillCategories)
    : [skillCategories[activeCategory]];

  return (
    <div className="skills-container">
      <h2 className="skills-title">Professional DNA</h2>
      <p className="skills-subtitle">My technical expertise visualized as interconnected skills</p>
      
      <div className="category-filters">
        <button 
          className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
          onClick={() => setActiveCategory('all')}
        >
          All Skills
        </button>
        {Object.keys(skillCategories).map(category => (
          <button
            key={category}
            className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
            onClick={() => setActiveCategory(category)}
            style={{ borderBottom: `3px solid ${skillCategories[category].color}` }}
          >
            {skillCategories[category].title}
          </button>
        ))}
      </div>

      <div className="dna-container">
        <div className="dna-strand">
          {filteredSkills.map((category, categoryIndex) => (
            <div key={categoryIndex} className="skill-category">
              <h3 
                className="category-title"
                style={{ color: category.color }}
              >
                {category.title}
              </h3>
              <div className="skills-grid">
                {category.skills.map((skill, skillIndex) => (
                  <div
                    key={skillIndex}
                    className={`skill-item ${animatedSkills.includes(skill) ? 'animated' : ''}`}
                    style={{
                      animationDelay: `${skillIndex * 0.1}s`,
                      border: `2px solid ${category.color}`,
                      backgroundColor: `${category.color}22`
                    }}
                  >
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="dna-helix">
          <div className="dna-line" style={{ background: 'linear-gradient(to right, #4CAF50, #2196F3, #FF9800, #9C27B0, #F44336)' }}></div>
          <div className="nucleotides">
            {Object.values(skillCategories).flatMap(category => 
              category.skills.map((skill, index) => (
                <div 
                  key={`${category.title}-${skill}`} 
                  className="nucleotide"
                  style={{ 
                    backgroundColor: category.color,
                    animationDelay: `${index * 0.5}s`
                  }}
                ></div>
              ))
            )}
          </div>
          <div className="dna-line" style={{ background: 'linear-gradient(to right, #F44336, #9C27B0, #FF9800, #2196F3, #4CAF50)' }}></div>
        </div>
      </div>
    </div>
  );
};

export default Skill;